var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"b-link",class:( _obj = {}, _obj['b-link--minor'] = _vm.minor, _obj['b-link--light'] = _vm.$voicer.isLightTheme && !_vm.primary, _obj['b-link--dark'] = _vm.$voicer.isDarkTheme && !_vm.primary, _obj['primary--text'] =  _vm.primary, _obj ),attrs:{"to":_vm.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }